export default {"src":"/_next/static/image/public/images/ic_pay_applepay.1b4659736d6779d116df3159b8fff9fe.svg","height":15,"width":38};